'use client';

/* Hotjar disabled — uncomment to re-enable.
import { useEffect, useRef } from 'react';
import Hotjar from '@hotjar/browser';
import { logger } from '@/lib/logger';
import { useCookieConsentStore } from '@/stores/cookie-consent.store';
import { useThemeStore } from '@/stores/theme.store';

const HOTJAR_VERSION = 6;
*/

export function HotjarProvider({ children }: { children: React.ReactNode }) {
  /* Hotjar init disabled — re-enable by uncommenting the imports above and the effect below.
  const analyticsConsent = useCookieConsentStore((state) => state.preferences.analytics);
  const theme = useThemeStore((state) => state.theme);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!theme || !analyticsConsent || initializedRef.current) return;

    const hotjarKey = theme.hotjarKey ?? process.env.NEXT_PUBLIC_HOTJAR_KEY;

    if (!hotjarKey) return;

    try {
      Hotjar.init(Number(hotjarKey), HOTJAR_VERSION);
      initializedRef.current = true;
      logger.info('Hotjar initialized successfully', {
        feature: 'hotjar',
        route: 'init',
      });
    } catch (error) {
      logger.warn('Failed to initialize Hotjar', {
        feature: 'hotjar',
        route: 'init',
        error,
      });
    }
  }, [theme, analyticsConsent]);
  */
  return <>{children}</>;
}
